import { Checkbox, Input } from '@sam/components';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { InventoryCategory, InventoryEntry, InventoryMetaType, Language } from 'shared';
import { useUser } from '../UserContext';

export const InventoryDetailInformation: React.FC<{
  entry: InventoryEntry;
  update: Dispatch<SetStateAction<InventoryEntry>>;
  category: InventoryCategory;
}> = ({ entry, update, category }) => {
  const { user } = useUser();

  /**
   * Holds the actual input elements for the detailInformations
   */
  const content: React.JSX.Element[] = useMemo((): React.JSX.Element[] => {
    const content: React.JSX.Element[] = [];
    category.informations.map((info) => {
      switch (info.type) {
        case InventoryMetaType.TEXT:
          content.push(
            <Input
              key={info.title + '-' + info.id}
              value={entry.metaInformations.get(info.id)}
              label={info.translations.get(user.language || Language.DE) || info.title}
              type="text"
              onChange={(value) => {
                const meta: Map<string, string> = entry.metaInformations;
                meta.set(info.id, value);
                update({ ...entry, metaInformations: meta });
              }}
            />,
          );
          break;
        case InventoryMetaType.NUMBER:
          content.push(
            <Input
              key={info.title + '-' + info.id}
              value={Number(entry.metaInformations.get(info.id))}
              label={info.translations.get(user.language || Language.DE) || info.title}
              type="number"
              onChangeNumber={(value) => {
                const meta: Map<string, string> = entry.metaInformations;
                meta.set(info.id, value.toString());
                update({ ...entry, metaInformations: meta });
              }}
            />,
          );
          break;
        case InventoryMetaType.CHECKBOX:
          content.push(
            <Checkbox
              key={info.title + '-' + info.id}
              label={info.translations.get(user.language || Language.DE) || info.title}
              isChecked={entry.metaInformations.get(info.id) === 'true'}
              onCheck={(checked) => {
                const meta: Map<string, string> = entry.metaInformations;
                meta.set(info.id, checked.toString());
                update({ ...entry, metaInformations: meta });
              }}
            />,
          );
          break;
        case InventoryMetaType.DATE:
          content.push(
            <Input
              key={info.title + '-' + info.id}
              value={
                entry.metaInformations.get(info.id)
                  ? new Date(entry.metaInformations.get(info.id)!)
                  : undefined
              }
              label={info.translations.get(user.language || Language.DE) || info.title}
              type="date"
              onChangeDate={(value) => {
                const meta: Map<string, string> = entry.metaInformations;
                if (value) meta.set(info.id, value?.toDateString());
                update({ ...entry, metaInformations: meta });
              }}
            />,
          );
          break;
      }
    });
    return content;
  }, [category, entry, update, user.language]);

  return <div className="three-columns">{content}</div>;
};
